import React, { useCallback, useEffect } from "react";
import './Empty.scss';
import Spinner from "../Spinner/Spinner";
import { Button, Col, Container, Row } from "react-bootstrap";
import nvCookieHelpers from "../../services/cookieService";
import { useHeaderMenu } from "../../contexts/login.context";
import useLoader from "../../contexts/LoaderContext";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../services/authService";
import { useLocation } from "react-router-dom";
import { useLocalization } from '../../contexts/LocalizationContext';
const Empty = () => {
    const { setLoginStatus, setItemsInCart } = useHeaderMenu();
    const { InvalidateCheckoutSession } = useAuth();
    const { t } = useTranslation();
    const { state } = useLocation();
    const msgString = (state?.msg) ? (state?.msg) : t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY');
    const { isLoading, showLoader, hideLoader } = useLoader();
    const { locale } = useLocalization();
    setItemsInCart(0);
    sessionStorage.removeItem('type');
    sessionStorage.removeItem('guest');
    sessionStorage.removeItem('customer');
    sessionStorage.removeItem('loggedIn');
    sessionStorage.removeItem('isShipping');
    nvCookieHelpers.deleteCookie('checkout');
    sessionStorage.removeItem('checkoutClicked');
    nvCookieHelpers.deleteCookie('sessionDetails');
    const handleSessionInvalidateSuccess = useCallback(() => {
        console.log('Logged Out!');
        const isUserLoggedInCookie = nvCookieHelpers.getCookie('isUserLoggedIn');
        hideLoader();
        if(isUserLoggedInCookie && isUserLoggedInCookie !== '') {
            setLoginStatus(JSON.parse(isUserLoggedInCookie));
            sessionStorage.setItem('loggedIn', 'true');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSessionInvalidateError = useCallback(() => {
        console.log('Logged Out!');
        hideLoader();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const invalidateSession = () => {
        showLoader();
        try {
            InvalidateCheckoutSession(handleSessionInvalidateSuccess, handleSessionInvalidateError);
            setLoginStatus(false)
        } catch (error) {
            hideLoader();
        }
    }
    useEffect(() => {
        invalidateSession();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const returnStore = () => {
        const decodedURL = locale === 'en-hk' ? 'https://www.nvidia.cn/geforce/' : (locale === 'en-ph'||locale === 'fi-fi'|| locale === 'da=dk') ? `https://marketplace.nvidia.com/${locale}/consumer/` : `https://marketplace.nvidia.com/${locale === 'en-me' ? 'en-us' : locale}`;
        if (decodedURL && decodedURL !== '') {
            window.location.href = decodedURL;
        }
    }
    return (
        <div className="EmptyCart">
            {isLoading ? (
                <Spinner />
            ) : (
                <Container>
                    <Row xs={'auto'} md={'auto'}>
                        <Col md={12}>
                            <p className="dr_emptyCart">{msgString}</p>
                            <Button className="storeCTA" onClick={returnStore}>{t('BTN_CONTINUE_SHOPPING')}</Button>
                        </Col>
                    </Row>
                </Container>
            )}
        </div>
    )
}

export default Empty;